"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ReceiveComponent = _interopRequireDefault(require("./ReceiveComponent"));
var _kycLevelsSelectors = require("./../../../redux/selectors/kycLevelsSelectors");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _depositWithdrawalSelectors = require("../../../redux/selectors/depositWithdrawalSelectors");
var _positionSelectors = require("../../../redux/selectors/positionSelectors");
var _userSelectors = require("../../../redux/selectors/userSelectors");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var hasSuperUserPermission = (0, _userSelectors.isSuperUser)(state);
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableDeposit = _kycVerificationLevel.disableDeposit;
  var _ref = (0, _depositWithdrawalSelectors.productDepositLimitsSelector)(state) || {},
    DailyDepositLimit = _ref.DailyDepositLimit,
    DailyDepositNotionalLimit = _ref.DailyDepositNotionalLimit,
    MonthlyDepositLimit = _ref.MonthlyDepositLimit,
    MonthlyDepositNotionalLimit = _ref.MonthlyDepositNotionalLimit,
    YearlyDepositLimit = _ref.YearlyDepositLimit,
    YearlyDepositNotionalLimit = _ref.YearlyDepositNotionalLimit;
  var productId = (0, _lodash.get)(ownProps, 'product.ProductId', null);
  var _positionByProductIdS = (0, _positionSelectors.positionByProductIdSelector)(productId)(state),
    TotalDayDeposits = _positionByProductIdS.TotalDayDeposits,
    TotalDayDepositNotional = _positionByProductIdS.TotalDayDepositNotional,
    TotalMonthDeposits = _positionByProductIdS.TotalMonthDeposits,
    TotalMonthDepositNotional = _positionByProductIdS.TotalMonthDepositNotional,
    TotalYearDeposits = _positionByProductIdS.TotalYearDeposits,
    TotalYearDepositNotional = _positionByProductIdS.TotalYearDepositNotional;
  var dailyLimitDisabled = TotalDayDeposits >= DailyDepositLimit && DailyDepositLimit !== -1 || DailyDepositLimit === 0;
  var dailyNotionalLimitDisabled = TotalDayDepositNotional >= DailyDepositNotionalLimit && DailyDepositNotionalLimit !== -1 || DailyDepositNotionalLimit === 0;
  var monthlyLimitDisabled = TotalMonthDeposits >= MonthlyDepositLimit && MonthlyDepositLimit !== -1 || MonthlyDepositLimit === 0;
  var monthlyNotionalLimitDisabled = TotalMonthDepositNotional >= MonthlyDepositNotionalLimit && MonthlyDepositNotionalLimit !== -1 || MonthlyDepositNotionalLimit === 0;
  var yearlyLimitDisabled = TotalYearDeposits >= YearlyDepositLimit && YearlyDepositLimit !== -1 || YearlyDepositLimit === 0;
  var yearlyNotionalLimitDisabled = TotalYearDepositNotional >= YearlyDepositNotionalLimit && YearlyDepositNotionalLimit !== -1 || YearlyDepositNotionalLimit === 0;
  var showDepositLimitWarningMessage = (dailyLimitDisabled || dailyNotionalLimitDisabled || monthlyLimitDisabled || monthlyNotionalLimitDisabled || yearlyLimitDisabled || yearlyNotionalLimitDisabled) && !hasSuperUserPermission;
  return {
    disableDeposit: disableDeposit,
    showDepositLimitWarningMessage: showDepositLimitWarningMessage
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verificationOnClick: function verificationOnClick() {
      return dispatch((0, _sidePaneActions.closeSidePane)());
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ReceiveComponent["default"]);